// ============================================================
// HABIT OS — Rechtstexte (Impressum, Datenschutzerklärung)
//
// Einzige Quelle für die App-Seiten (LegalSheet.jsx).
// Die Texte stammen aus docs/DATENSCHUTZ-ENTWURF.md und
// docs/IMPRESSUM-ENTWURF.md. Änderungen immer in beiden pflegen.
//
// Eckige Klammern [ … ] im Text sind offene Punkte für die
// anwaltliche Prüfung. Solange LEGAL_GEPRUEFT false ist, sind sie
// sichtbar und die Seiten tragen einen Entwurfs-Hinweis. Erst wenn
// die Prüfung durch ist: Klammern auflösen, dann auf true setzen.
// ============================================================

export const LEGAL_STAND    = "3. November 2026";
export const LEGAL_GEPRUEFT = false;

export const IMPRESSUM = {
  titel: "Impressum",
  bloecke: [
    { t: "h", text: "Angaben gemäß § 5 DDG" },
    { t: "p", text: "Sven Möller\nterra n'type\nGrüner Redder 6\n21029 Hamburg\nDeutschland" },
    { t: "h", text: "Kontakt" },
    { t: "p", text: "E-Mail: hello@terra-type.com\nTelefon: +49 179 88 92 187" },
    { t: "h", text: "Umsatzsteuer-Identifikationsnummer" },
    { t: "p", text: "gemäß § 27a Umsatzsteuergesetz: DE311538406" },
    { t: "h", text: "Verantwortlich für den Inhalt" },
    { t: "p", text: "nach § 18 Abs. 2 MStV: Sven Möller, Anschrift wie oben" },
    { t: "h", text: "Verbraucherstreitbeilegung" },
    { t: "p", text: "Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen." },
    { t: "h", text: "Werbung und Partnerlinks" },
    { t: "p", text: "Partnerlinks sind in der App als „Anzeige“ gekennzeichnet. Mehr dazu unter „So prüfen wir“ im Begleiter." },
  ],
};

export const DATENSCHUTZ = {
  titel: "Datenschutzerklärung",
  abschnitte: [
  {
    "titel": "Verantwortlicher",
    "bloecke": [
      {
        "t": "p",
        "text": "Sven Möller, Inhaber von terra n'type\nGrüner Redder 6, 21029 Hamburg\nE-Mail: hello@terra-type.com\nTelefon: +49 179 88 92 187"
      },
      {
        "t": "p",
        "text": "Ein Datenschutzbeauftragter ist [benannt: Kontakt … / nicht erforderlich, Begründung prüfen]."
      }
    ]
  },
  {
    "titel": "Bereitstellung der App (Hosting)",
    "bloecke": [
      {
        "t": "p",
        "text": "Die App wird über **Vercel Inc.** (USA) ausgeliefert. Beim Aufruf verarbeitet Vercel technisch notwendige Daten (IP-Adresse, Zeitpunkt, abgerufene Datei, Browserkennung) in Server-Logs. Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO (sichere und stabile Bereitstellung). Übermittlung in die USA: [Garantie prüfen: Data Privacy Framework oder Standardvertragsklauseln im Auftragsverarbeitungsvertrag mit Vercel]. Speicherdauer der Logs: [laut Vercel prüfen]."
      }
    ]
  },
  {
    "titel": "Konto und Anmeldung",
    "bloecke": [
      {
        "t": "p",
        "text": "Für dein Konto speichern wir E-Mail-Adresse, Anzeigename und ein verschlüsseltes Passwort bei **Supabase** (Rechenzentrum Frankfurt, EU; Anbieter Supabase Inc., USA). Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (Vertrag). [Auftragsverarbeitungsvertrag mit Supabase abschließen bzw. nachweisen.]"
      },
      {
        "t": "p",
        "text": "**Anmeldung mit Google (optional):** Wenn du dich mit Google anmeldest, erhalten wir von Google deine E-Mail-Adresse, deinen Namen und ggf. dein Profilbild. Anbieter: Google Ireland Limited bzw. Google LLC (USA). Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO. [Drittlandübermittlung und Hinweis auf Googles Datenschutzerklärung ergänzen.]"
      }
    ]
  },
  {
    "titel": "Gewohnheiten, Routinen und Fortschritt",
    "bloecke": [
      {
        "t": "p",
        "text": "Wir speichern deine Gewohnheiten, Routinen, erledigten Einträge, Streaks und Einstellungen bei Supabase in Frankfurt, um die App bereitzustellen. Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO. Einige Gewohnheiten (z. B. Nahrungsergänzungsmittel) können Rückschlüsse auf deine Gesundheit erlauben. [Prüfen lassen, ob dafür bereits eine Einwilligung nach Art. 9 Abs. 2 lit. a DSGVO nötig ist, auch ohne KI-Begleiter.]"
      },
      {
        "t": "p",
        "text": "Speicherdauer: bis du die Einträge oder dein Konto löschst."
      }
    ]
  },
  {
    "titel": "KI-Begleiter und Etikett-Analyse (Einwilligung)",
    "bloecke": [
      {
        "t": "p",
        "text": "Nur wenn du ausdrücklich einwilligst, verarbeiten wir für den KI-Begleiter:"
      },
      {
        "t": "ul",
        "items": [
          "deine Chat-Nachrichten,",
          "Fotos von Supplement-Etiketten,",
          "deine Gewohnheiten mit Fortschritt (z. B. erledigte Habits, Streak)."
        ]
      },
      {
        "t": "p",
        "text": "Daraus können sich Gesundheitsdaten ergeben. Zweck: Antworten des Begleiters, Etikett-Analyse (Vergleich mit den BfR-Höchstmengen), Wochenrückblick und Push-Nachrichten des Begleiters."
      },
      {
        "t": "ul",
        "items": [
          "**Rechtsgrundlage:** Art. 9 Abs. 2 lit. a i. V. m. Art. 6 Abs. 1 lit. a DSGVO (Einwilligung). Die Einwilligung wird mit Zeitpunkt und Textfassung protokolliert (Tabelle `consents`, Version `2026-11-02`).",
          "**Empfänger:** Supabase (Speicherung, Frankfurt) und **Anthropic PBC** (USA), das aus den Daten die Antworten erzeugt. [Garantie für die Drittlandübermittlung prüfen und nennen: Data Privacy Framework oder Standardvertragsklauseln im Data Processing Addendum von Anthropic.] Laut Anthropics kommerziellen Bedingungen werden API-Daten nicht zum Training verwendet. [Aufbewahrungsfrist bei Anthropic aus deren aktuellen Bedingungen übernehmen.]",
          "**Speicherdauer:** Der Chatverlauf bleibt gespeichert, bis du ihn im Profil unter „Datenschutz → Chatverlauf löschen“ oder mit deinem Konto löschst.",
          "**Widerruf:** jederzeit im Profil unter „Datenschutz“. Danach sendet die App nichts mehr an Anthropic; das wird auch auf dem Server geprüft. Die Rechtmäßigkeit der bisherigen Verarbeitung bleibt unberührt.",
          "**Keine automatisierte Entscheidung** im Sinne von Art. 22 DSGVO. Der Begleiter stellt keine Diagnosen und gibt keine Dosierungsempfehlungen."
        ]
      }
    ]
  },
  {
    "titel": "Push-Benachrichtigungen",
    "bloecke": [
      {
        "t": "p",
        "text": "Wenn du Push aktivierst, speichern wir die technische Adresse deines Geräts beim Push-Dienst (Apple, Google oder Mozilla, je nach Gerät und Browser), deine Zeitzone und deine Zeiteinstellungen. Der Inhalt der Nachricht wird über diesen Push-Dienst zugestellt. Rechtsgrundlage: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung über die Browser-Abfrage) [prüfen]. Abschalten jederzeit im Profil oder in den Geräteeinstellungen."
      }
    ]
  },
  {
    "titel": "Partnerprodukte (Affiliate)",
    "bloecke": [
      {
        "t": "p",
        "text": "Nach einer Etikett-Analyse kannst du dir ein gekennzeichnetes Partnerprodukt ansehen. Erst wenn du auf „Zum Shop“ tippst, wirst du zum Partnernetzwerk **Awin** bzw. zum Shop weitergeleitet. Dort gelten deren Datenschutzbestimmungen; Awin kann Cookies setzen, um den Kauf zuzuordnen. Habit OS selbst setzt dafür keine Tracking-Cookies. [Prüfen, sobald echte Links aktiv sind.]"
      }
    ]
  },
  {
    "titel": "Speicherung auf deinem Gerät",
    "bloecke": [
      {
        "t": "p",
        "text": "Die App speichert Einstellungen im lokalen Speicher deines Browsers (`localStorage`): Darstellung (hell/dunkel), Sprache, Avatarfarbe, Erinnerungszeiten, Onboarding-Status, Hinweis zur App-Installation, letztes Nutzungsdatum. Das ist für die von dir gewünschten Funktionen unbedingt erforderlich (§ 25 Abs. 2 Nr. 2 TDDDG). Es werden keine Analyse- oder Werbe-Tracker eingesetzt."
      }
    ]
  },
  {
    "titel": "Schriftarten",
    "bloecke": [
      {
        "t": "p",
        "text": "Die Schriften Manrope und Plus Jakarta Sans werden von unserem eigenen Server ausgeliefert. Es findet keine Verbindung zu Google Fonts statt."
      }
    ]
  },
  {
    "titel": "Deine Rechte",
    "bloecke": [
      {
        "t": "p",
        "text": "Du hast das Recht auf Auskunft (Art. 15), Berichtigung (Art. 16), Löschung (Art. 17), Einschränkung (Art. 18), Datenübertragbarkeit (Art. 20) und Widerspruch (Art. 21 DSGVO) sowie das Recht, Einwilligungen jederzeit zu widerrufen (Art. 7 Abs. 3). Dein Konto kannst du im Profil unter „Konto löschen“ selbst löschen."
      },
      {
        "t": "p",
        "text": "Beschwerderecht bei einer Aufsichtsbehörde, z. B. bei der Hamburgischen Beauftragten für Datenschutz und Informationsfreiheit (Sitz des Verantwortlichen: Hamburg)."
      }
    ]
  }
],
};
